import { Component, Input, AfterViewInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { AeroplantasService } from '@shared/aeroplantas.service';
import { TipoVenta } from '@shared/enums/tipoVenta';
import { ConsultaPrecioFacturaDTO } from '@shared/models/precios/ConsultaPrecioFacturaDTO';
import { UtilPrecio } from '@shared/utiles/UtilPrecios';
import { VisorComprobanteComponent } from '@shared/visor-comprobante/visor-comprobante.component';
import { MessageService } from '@shell/message.service';
import { environment } from '@environments';

@Component({
  selector: 'app-listado-precios-facturados',
  templateUrl: './listado-precios-facturados.component.html',
  styleUrls: ['./listado-precios-facturados.component.css']
})
export class ListadoPreciosFacturadosComponent implements AfterViewInit {
    
  @Input() listadoPrecios :  ConsultaPrecioFacturaDTO[];
  @Input() esperandoCarga: boolean;
  
  tablaPreciosFacturados = new UntypedFormGroup({ });
  listadoPreciosFiltrados :  ConsultaPrecioFacturaDTO[];
  linkGrafana = environment.grafana.preciosUtilizados;

  obteniendoComprobante: boolean = false;

  busquedaFormControl=new UntypedFormControl();
  
  constructor(
    public utilPrecio: UtilPrecio, 
    public aeroplantaService:AeroplantasService,
    private messageService: MessageService,
    private modal: NgbModal,
    private comprobanteService: ComprobanteService) { 

  }

  ngAfterViewInit() {
    $("#grafana").on("load", function(){
      console.log("load grafana");
       
      $(this).contents().find('head').children().append("<style> .sidemenu{ display: none !important; } </style>");
      
      $(this).contents().find('head').children().append("<style> div.css-6v8co2{ display: none !important; } button.css-1j9p9hg{ display: none !important; } button.css-m46xa3{ display: none !important; } div.css-umstnt{ display: none !important; } </style>");
    });
  }
/*
  filtrarPrecios() {
    this.listadoPreciosFiltrados = this.listadoPrecios.filter(a => {
      let agregar = true;

      if (this.busqueda.value) {
        agregar = agregar && a.razonSocial.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;        
        agregar = agregar || (a.numeroDocumento && a.numeroDocumento.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || ((a.prefijo.toString() + "-" + a.numeroComprobante.toString()).indexOf(this.busqueda.value) > -1);

      }
      
      return agregar;
    });   

    console.log("a");
  }
    */

  get busqueda() {
    return this.busquedaFormControl;
  }

  obtenerTipoVenta(i:number)
  {
    if(i == 0){
      return "-";
    }
    
    return TipoVenta[i];
  }

  mostrarFactura(id) {
    this.obteniendoComprobante = true;
    this.comprobanteService.obtenerComprobantePorId(id)
      .subscribe(result => {
        const comprobante = result;
        this.obteniendoComprobante = false;
        if (comprobante != null) {
          const modalRef = this.modal.open(VisorComprobanteComponent, { centered: true, size: 'lg' });
          modalRef.componentInstance.facturaObtenida = comprobante;
        }else{
          this.messageService.showErrorMessage('Error al obtener la factura');
        }
      }, () =>{
        this.messageService.showErrorMessage('Error al obtener la factura');
      });
  }

}

